export default {
  WP_API_URL: 'https://blog.nmrih2.com/?rest_route=/',
}



// WEBPACK FOOTER //
// ./src/config.js